module.exports = __webpack_public_path__ + "static/media/FAU_Red.97c440db.png";